import React from 'react'
import SiteGrid from "../ui/SiteGrid"
import AppButton from "../ui/AppButton"
import SquareGrid from "../ui/SquareGrid"
import './styles/MakeAppointment.css'

export default function MakeAppointment({className=''}) {
  return (
    <div className={`appointment-section ${className}`}>
      <SiteGrid className="appointment-flex">
        <div className="appointment-banner">
          <h6 className="title">Make an appointment</h6>
          <h2 className="title">Schedule Your Consultation Now</h2>
          <p>
            Our user-friendly online booking tool allows you to view
            available appointment times, select the date and time
            that works best for you, and book your visit in just
            a few clicks.
          </p>
          <AppButton
            label="Schedule Appointment"
            buttonType="outlineSecondaryBtn animate"
            rightIcon="fal fa-arrow-right"
            url="/make-an-appointment"
          />
          <div className="square-1"/>
          <div className="circle-1"/>
          <SquareGrid />
        </div>
      </SiteGrid>
    </div>
  )
}
